import { mergeMap, map, filter } from 'rxjs/operators';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Alert } from '../../model/alert';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  alerts: Alert[];

  constructor(private changeDetectionRef: ChangeDetectorRef, private errorService: ErrorService) {
  }

  ngOnInit() {
    this.updateAlerts();
  }

  updateAlerts() : void{
    this.alerts = this.errorService.alerts;
  }

  closeAlert(alert: Alert){
    this.errorService.close(alert);
    this.updateAlerts();
  }
}
